import styled from 'styled-components';
import { ModalHeader as BaseModalHeader, ModalContent as BaseModalContent, ModalContainer as BaseModalContainer } from 'components/BaseModal/styles';
import { colors } from 'styles/colors';
import { Button as BaseButton } from 'components/Button';

export const ModalContainer = styled(BaseModalContainer)`
  width: 390px;
  gap: 32px;

  @media (max-width: 768px) {
    height: fit-content;
  }
`;

export const ModalHeader = styled(BaseModalHeader)`
  & > div {
    display: flex;
    gap: 8px;
    align-items: center;

    & > h3 {
      margin: 0;
    }
  }
`;

export const ModalContent = styled(BaseModalContent)`
  flex-direction: column;
  align-items: center;
  padding: 0 6px;

  & > h4,
  & > h5,
  & > p {
    margin: 0;
    font-size: 14px;
    line-height: 180%;
    color: ${colors.text['main-900']};
    text-align: center;
  }

  & > h4 {
    margin-bottom: 8px;
    font-weight: 600;
  }

  & > h5 {
    margin-bottom: 4px;
    font-weight: 400;
  }

  & > p {
    margin-bottom: 16px;
    font-weight: 400;
    color: ${colors.text['sub-500']};
  }
`;

export const Button = styled(BaseButton)`
  width: 158px;
  height: 33px;
`;
